import { TbArrowRight } from "react-icons/tb";

import { PaymentRailChip } from "./PaymentRailChip";

export const PaymentRouteChips = ({
  originRailId,
  destinationRailId,
  fromCurrency,
  toCurrency,
  className = "",
  fixedWidth = true,
}) => {
  if (!fromCurrency || !toCurrency) return "—";

  return (
    <span
      className={`inline-flex items-center gap-x-1 ${fixedWidth ? "flex-nowrap" : "flex-wrap gap-y-0.5"} ${className}`}
    >
      <PaymentRailChip railId={originRailId} currencyId={fromCurrency} fixedWidth={fixedWidth} />
      <TbArrowRight className="h-3 w-3 shrink-0 text-gray-400" aria-hidden />
      <PaymentRailChip railId={destinationRailId} currencyId={toCurrency} fixedWidth={fixedWidth} />
    </span>
  );
};
